// Decorative editorial marquee — purely visual, aria-hidden, pauses on reduced-motion.
export default function Marquee() {
  const items = Array.from({ length: 8 });
  return (
    <div data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden py-6 border-y border-navy/10 bg-paper select-none">
      <div className="marquee">
        {items.concat(items).map((_, i) => (
          <span key={i} className="inline-flex items-center whitespace-nowrap px-8 font-display text-navy/25" style={{ fontSize: "clamp(1.3rem, 2.4vw, 2rem)" }}>
            لسياقك نبتكر
            <span className="mx-8 h-2 w-2 rotate-45 inline-block" style={{ backgroundColor: "var(--coral)" }} />
          </span>
        ))}
      </div>
    </div>
  );
}
